import { Component } from '@angular/core';

/**
 * @description Pie de página común a todo el sistema ("© {año} Contreras ·
 * Desarrollado por Blister"). Se usa como hermano `shrink-0` del área de
 * contenido con scroll dentro de cada shell (home-page, home/capacitaciones,
 * hse, administración) — mismo mecanismo que ya usaba `ticket.component.html`
 * para quedar siempre visible sin superponerse al contenido ni al sidebar.
 */
@Component({
  selector: 'c-footer',
  templateUrl: './footer.component.html',
  standalone: false,
})
export class FooterComponent {
  readonly currentYear = new Date().getFullYear();
}
